export default "__VITE_ASSET__uzBmOejJ__"